import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { UnfinishedSetups } from '@/components/agent/recovery/UnfinishedSetups';
import { SetupRecoveryService } from '@/services/agent/recovery';
import { toast } from 'sonner';

const UnfinishedSetupsPage = () => {
  const navigate = useNavigate();

  const handleResumeSetup = async (conversationId: string) => {
    try {
      console.log("Resuming setup from conversation:", conversationId);

      const { transcript, analysis } = await SetupRecoveryService.resumeSetupFromConversation(conversationId);

      sessionStorage.setItem(
        "resumedSetupData",
        JSON.stringify({
          conversationId,
          transcript,
          analysis,
          isResumed: true,
        })
      );

      window.location.href = "/user-hub/genie-setup";
    } catch (error) {
      console.error("Failed to resume setup:", error);
      const errorMessage = error instanceof Error ? error.message : String(error);

      if (errorMessage.includes("transcript") || errorMessage.includes("conversation")) {
        toast.error("We could not bring that setup back", {
          description:
            "This one was started before we began saving setups as you go, so there is nothing left to restore. A new setup is saved automatically.",
        });
      } else {
        toast.error("Failed to resume setup. Please try again.");
      }
      throw error;
    }
  };

  return (
    <div className="min-h-screen bg-[#F9FAFC]">
      <div className="container mx-auto px-4 py-6 md:py-8 max-w-[1920px]">
        <div className="mb-6">
          <Button
            variant="ghost"
            onClick={() => navigate('/genie-hub/my-genies')}
            className="gap-2 text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to My Genies
          </Button>
        </div>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Unfinished Genie Setups</h1>
          <p className="text-gray-600">Resume your setup or remove incomplete setups from this list</p>
        </div>

        <UnfinishedSetups onResumeSetup={handleResumeSetup} />
      </div>
    </div>
  );
};

export default UnfinishedSetupsPage;
